import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export const QUERY_KEY_FOR_SUGGESTED_JOBS = "suggested-jobs";

export interface Job {
    id: string;
    title: string;
    company_name: string;
    location_city: string;
    location_country: string;
    description: string;
    created_at: string;
    expiry_date?: string;
    type: string;
    level?: string;
    has_bookmarked?: boolean;
    has_liked?: boolean;
}

interface SuggestedJobsResponse {
    data: Job[];
    total?: number;
    [key: string]: any;
}

const fetchSuggestedJobs = async (token: string): Promise<SuggestedJobsResponse> => {
    const url = `${END_POINT.BASE_URL}/v1/job-suggestions-list`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.get(url, config);
    return response.data;
};

export const useGetSuggestedJobs = () => {
    const { token } = useGetUserInfo();

    return useQuery(
        [QUERY_KEY_FOR_SUGGESTED_JOBS],
        () => fetchSuggestedJobs(token),
        {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            enabled: !!token,
            staleTime: 5 * 60 * 1000,
            retry: 1,
        }
    );
};
